import {Point} from '@logistics-frontend/core/types'

import {PerformerPinDefault, PerformerPinLoadable} from 'src/api/cargo-c2c/types'
import {Brand} from 'src/config/types'

export type RouterParams = {
  sharingKey: string
}

export const enum MapModes {
  SearchCourier = 'search_courier',
  WaitCourier = 'wait_courier',
  Transporting = 'transporting',
  Delivered = 'delivered',
}

export type SharedRoutePageContextI = {
  isGroceryOrder?: boolean
  brand?: Brand
  token?: string
  vendor?: 'beru' | string
}

export type PerformerType = 'default' | 'loadable'

export type RoutePoint = {
  point: Point
  index: number
}

export type MapData = {
  bubbleText?: string
  route?: RoutePoint[]
  position?: Point
  direction?: number
  pin?: PerformerPinDefault | PerformerPinLoadable
  mode: MapModes
}

export {Brand}
